import * as React from "react";
import type { SVGProps } from "react";
const SvgSmartHomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M13.98 1.12a.56.56 0 0 0-.326.12L.774 11.32a.56.56 0 1 0 .692.88l.774-.605V26.32a.56.56 0 0 0 .56.56h22.4a.56.56 0 0 0 .56-.56V11.595l.774.606a.558.558 0 0 0 .886-.29.56.56 0 0 0-.194-.592L14.346 1.24a.56.56 0 0 0-.366-.119M14 2.39l10.64 8.328V25.76H3.36V10.718zm0 8.81a11.16 11.16 0 0 0-7.795 3.174l.792.79a10.04 10.04 0 0 1 14.006 0l.792-.79A11.16 11.16 0 0 0 14 11.2m0 2.8c-2.257 0-4.305.9-5.815 2.353l.791.791a7.246 7.246 0 0 1 10.048 0l.791-.791A8.37 8.37 0 0 0 14 14m0 2.8a5.58 5.58 0 0 0-3.837 1.531l.792.792A4.46 4.46 0 0 1 14 17.92c1.176 0 2.245.459 3.045 1.203l.79-.79A5.57 5.57 0 0 0 14 16.8m0 2.8a1.12 1.12 0 1 0 0 2.24 1.12 1.12 0 0 0 0-2.24"
    />
  </svg>
);
export default SvgSmartHomeIcon;
